

























import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["accountBook"])
})
export default class CapPrint extends Vue {

    @Prop({ type: String })
    endPeriod!: string;

    @Prop({ type: Number, default: 3 })
    firstCol!: number;

    @Prop({ type: Number, default: 1 })
    secondCol!: number;

    @Prop({ type: Number, default: 1 })
    thirdCol!: number;

    @Prop({ type: String })
	fontSize!: string;

    period: string = "";

    mounted() {
        this.endPeriodChange(this.endPeriod);
    }

    @Watch("endPeriod")
    endPeriodChange(val: string) {
        if (val != "") {
            if (!val.includes("至")) this.period = val.substring(0, 4) + "年" + val.substring(4) + "月";
            else this.period = val;
        }
    }
}
